module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "FireAlarmUi": "static-1.3487",
      "foundations-theming-base": "static-1.1916",
      "hubspot-url-utils": "static-1.3002",
      "jasmine-runner": "static-1.5017",
      "quartz": "static-1.5372",
      "react": "static-7.151",
      "foundations-theming": "static-1.2931",
      "quick-fetch": "static-1.2772",
      "enviro": "static-4.297",
      "jasmine": "static-4.2969",
      "PortalIdParser": "static-2.276",
      "quartz-core-utils": "static-1.2239",
      "react-dom": "static-7.85",
      "StyleGuideUI": "static-3.453",
      "csstype": "static-1.38",
      "bend-plugin-foundations-theming": "static-1.1414",
      "framer-motion": "static-1.40",
      "hs-story-utils": "static-1.8012",
      "metrics-js": "static-1.8392",
      "react-utils": "static-2.4177",
      "styled-components": "static-2.40",
      "hoist-non-react-statics": "static-3.9"
    },
    "depPathPrefixes": {
      "FireAlarmUi": "/FireAlarmUi/static-1.3487",
      "foundations-theming-base": "/foundations-theming-base/static-1.1916",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3002",
      "jasmine-runner": "/jasmine-runner/static-1.5017",
      "quartz": "/quartz/static-1.5372",
      "react": "/react/static-7.151",
      "foundations-theming": "/foundations-theming/static-1.2931",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "enviro": "/enviro/static-4.297",
      "jasmine": "/jasmine/static-4.2969",
      "PortalIdParser": "/PortalIdParser/static-2.276",
      "quartz-core-utils": "/quartz-core-utils/static-1.2239",
      "react-dom": "/react-dom/static-7.85",
      "StyleGuideUI": "/StyleGuideUI/static-3.453",
      "csstype": "/csstype/static-1.38",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1414",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-story-utils": "/hs-story-utils/static-1.8012",
      "metrics-js": "/metrics-js/static-1.8392",
      "react-utils": "/react-utils/static-2.4177",
      "styled-components": "/styled-components/static-2.40",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9"
    },
    "project": "FireAlarmUi",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};